import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dictionaryTypes: [],
  editableDictionaryTypes: [],
  isEditing: false,
  isDitry: false,
  isLoading: false,
  isLocked: false,
  lockedBy: "",
};

export const dictionaryTypesSlice = createSlice({
  name: "dictionaryTypes",
  initialState,
  reducers: {
    setDictionaryTypes(state, { payload = [] }) {
      state.dictionaryTypes = payload;
    },
    setEditableDictionaryTypes(state, { payload = [] }) {
      state.editableDictionaryTypes = payload;
    },
    addType(state, { payload }) {
      const { type, index } = payload;
      state.isDitry = true;

      state.editableDictionaryTypes = [
        ...state.editableDictionaryTypes.slice(0, index + 1),
        type,
        ...state.editableDictionaryTypes.slice(index + 1),
      ];
    },
    updateType(state, { payload = {} }) {
      const { type, index } = payload;
      state.isDitry = true;
      state.editableDictionaryTypes = state.editableDictionaryTypes.map(
        (item, i) => {
          return i === index ? { ...item, ...type } : item;
        }
      );
    },
    removeType(state, action) {
      const index = action.payload;
      state.isDitry = true;
      state.editableDictionaryTypes = state.editableDictionaryTypes.filter(
        (_, i) => i !== index
      );
    },
    setIsEditing(state, { payload }) {
      state.isEditing = Boolean(payload);
    },
    setIsDitry: (state, { payload }) => {
      state.isDitry = Boolean(payload);
    },
    setIsLoading(state, { payload }) {
      state.isLoading = Boolean(payload);
    },
    setIsLocked(state, { payload }) {
      state.isLocked = Boolean(payload);
    },
    setLockedBy(state, { payload }) {
      state.lockedBy = payload;
    },
  },
});

export const {
  setDictionaryTypes,
  setEditableDictionaryTypes,
  addType,
  updateType,
  removeType,
  setIsEditing,
  setIsDitry,
  setIsLoading,
  setIsLocked,
  setLockedBy,
} = dictionaryTypesSlice.actions;

export default dictionaryTypesSlice.reducer;
